export default __webpack_public_path__ + "dist/media/Add-member-card-bg.911538aa.svg";